import { render, staticRenderFns } from "./mcs-table-card.vue?vue&type=template&id=1b67c232&"
import script from "./mcs-table-card.vue?vue&type=script&lang=js&"
export * from "./mcs-table-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports